module.exports = __webpack_public_path__ + "img/floors.596661f9.svg";